'use strict';

function CompanyPublicationEsignService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/shares/e-signs/:eSignId', {}, {
    'update': { method:'PUT' }
  });
}

angular.module('dokiv')
  .factory('CompanyPublicationEsignService', ['$resource', 'config', CompanyPublicationEsignService]);




//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationEsignService.js
// module id = 376
// module chunks = 0